// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___87df8248f730f464f22","cls2":"Comments-cls2__e0546de2bfbaef9cb4a5 Comments-cls1___87df8248f730f464f22"};